export default __webpack_public_path__ + "static/media/share.80f04ec2.svg";